import * as React from "react"
import {Grid} from "@mui/material";
import {formatPercentage} from "@ui-seeker/utils";

import {PriceEvolutionBaseWidget} from "../../@components"
import { priceEvolutionWidgetFormatPrice } from "../../@utils"



export default function PriceEvolutionWidgetSkuBlock({ data, isPercentage, useListPrice, dataMinMax, ...props }) {
	return data.map((d, idx) => {
		const value = useListPrice ? d.listKPI : d.actualKPI
		const numVariants = d.numVariants
		const prevValue = useListPrice ? d.listPrevKPI : d.actualPrevKPI
		const { maxValue, maxDates, minValue, minDates } = dataMinMax[d.skuID] || {}

		return <Grid item xs={3} key={idx}>
			<PriceEvolutionBaseWidget
				title={d.skuName}
				currentValue={value}
				current={isPercentage ? formatPercentage(value) : priceEvolutionWidgetFormatPrice(value, d.currency)}
				prevValue={prevValue}
				previous={isPercentage ? formatPercentage(prevValue) : priceEvolutionWidgetFormatPrice(prevValue, d.currency)}
				isPercentage={isPercentage}
				maxValue={formatPercentage(maxValue)}
				maxDates={maxDates}
				minValue={formatPercentage(minValue)}
				minDates={minDates}
				reverse={isPercentage}
				numVariants={numVariants}
				{...props}
			/>
		</Grid>
	})
}